import { useLocation } from "react-router-dom";
import { routes } from '../routes';

const linkColor = 'var(--accent-6)';

const useActiveMenu = () => {
  const location = useLocation();

  const getCurrentPage = () => {
    switch (location.pathname) {
      case routes.dashboard:
        return routes.routeName(routes.dashboard);
      case routes.users:
        return routes.routeName(routes.users);
      case routes.createUser:
        return routes.routeName(routes.createUser);
      case routes.updateUser:
        return routes.routeName(routes.users);
      case routes.roles:
        return routes.routeName(routes.roles);
      case routes.createRole:
        return routes.routeName(routes.createRole);
      case routes.addClaimsToRole:
        return routes.routeName(routes.addClaimsToRole);
      case routes.faculties:
        return routes.routeName(routes.faculties);
      case routes.updateFaculty:
        return routes.routeName(routes.faculties);
      case routes.updateFaculty:
        return routes.routeName(routes.updateFaculty);
      case routes.createFaculty:
        return routes.routeName(routes.createFaculty);
      case routes.departaments:
        return routes.routeName(routes.departaments);
      case routes.updateDepartament:
        return routes.routeName(routes.departaments);
      case routes.createDepartament:
        return routes.routeName(routes.createDepartament);
      case routes.updateDepartament:
        return routes.routeName(routes.updateDepartament);
      case routes.courses:
        return routes.routeName(routes.courses);
      case routes.updateCourse:
        return routes.routeName(routes.courses);
      case routes.createCourse:
        return routes.routeName(routes.createCourse);
      case routes.updateCourse:
        return routes.routeName(routes.updateCourse);
      case routes.scientificAreas:
        return routes.routeName(routes.scientificAreas);
      case routes.createScientificAreas:
        return routes.routeName(routes.createScientificAreas);
      case routes.updateScientificAreas:
        return routes.routeName(routes.updateScientificAreas);
      case routes.academicPeriods:
        return routes.routeName(routes.academicPeriods);
      case routes.createAcademicPeriod:
        return routes.routeName(routes.createAcademicPeriod);
      case routes.updateAcademicPeriod:
        return routes.routeName(routes.updateAcademicPeriod);
      case routes.subjects:
        return routes.routeName(routes.subjects);
      case routes.createSubject:
        return routes.routeName(routes.createSubject);
      case routes.updateSubject:
        return routes.routeName(routes.updateSubject);
      case routes.academicYears:
        return routes.routeName(routes.academicYears);
      case routes.enrollmentrequireddocuments:
        return routes.routeName(routes.enrollmentrequireddocuments);
      case routes.createEnrollmentRequiredDocument:
        return routes.routeName(routes.createEnrollmentRequiredDocument);
      case routes.updateEnrollmentRequiredDocument:
        return routes.routeName(routes.updateEnrollmentRequiredDocument);
      case routes.createEnrollment:
        return routes.routeName(routes.createEnrollment);
      case routes.enrollments:
        return routes.routeName(routes.enrollments);
      case routes.updateEnrollment:
        return routes.routeName(routes.updateEnrollment);
      case routes.teacherRequiredDocuments:
        return routes.routeName(routes.teacherRequiredDocuments);
      case routes.createTeacherRequiredDocument:
        return routes.routeName(routes.createTeacherRequiredDocument);
      case routes.updateTeacherRequiredDocument:
        return routes.routeName(routes.updateTeacherRequiredDocument);
      case routes.teachers:
        return routes.routeName(routes.teachers);
      case routes.createTeacher:
        return routes.routeName(routes.createTeacher);
      case routes.updateTeacher:
        return routes.routeName(routes.updateTeacher);
      case routes.classes:
        return routes.routeName(routes.classes);
      case routes.createClass:
        return routes.routeName(routes.createClass);
      case routes.updateClass:
        return routes.routeName(routes.updateClass);
      case routes.blockOrUnblockStudentGradePosting:
        return routes.routeName(routes.blockOrUnblockStudentGradePosting);
      case routes.assessments:
        return routes.routeName(routes.assessments);
      case routes.createAssessments:
        return routes.routeName(routes.createAssessments);
      case routes.updateAssessments:
        return routes.routeName(routes.updateAssessments);
      // case routes.coursesSubjects:
      //   return routes.routeName(routes.coursesSubjects);
      case routes.coursePlans:
        return routes.routeName(routes.coursePlans);
      case routes.createCoursePlan:
        return routes.routeName(routes.createCoursePlan);
      case routes.createCourseSubject:
        return routes.routeName(routes.createCourseSubject);
      case routes.updateCourseSubject:
        return routes.routeName(routes.updateCourseSubject);
      case routes.createMySubscription:
        return routes.routeName(routes.createMySubscription);
      case routes.createSubscription:
        return routes.routeName(routes.createSubscription);
      case routes.updateSubscription:
        return routes.routeName(routes.updateSubscription);
      case routes.subscriptions:
        return routes.routeName(routes.subscriptions);
      case routes.subscriptionsValidation:
        return routes.routeName(routes.subscriptionsValidation);
      case routes.studentSubscription:
        return routes.routeName(routes.studentSubscription);
      case routes.userRoleAndCLaims:
        return routes.routeName(routes.users);
      case routes.addStudentGradesV2:
        return routes.routeName(routes.addStudentGradesV2);
      case routes.addStudentGrades:
        return routes.routeName(routes.addStudentGrades);
      case routes.addStudentExamGrades:
        return routes.routeName(routes.addStudentExamGrades);
      case routes.generalStudentGrades:
        return routes.routeName(routes.generalStudentGrades);
      case routes.viewStudentGrades:
        return routes.routeName(routes.viewStudentGrades);
      case routes.viewStudentExamGrades:
        return routes.routeName(routes.viewStudentExamGrades);
      case routes.createClassroom:
        return routes.routeName(routes.createClassroom);
      case routes.updateClassroom:
        return routes.routeName(routes.classrooms);
      case routes.classrooms:
        return routes.routeName(routes.classrooms);
      case routes.classroomTypes:
        return routes.routeName(routes.classroomTypes);
      case routes.createClassroomType:
        return routes.routeName(routes.createClassroomType);
      case routes.updateClassroomType:
        return routes.routeName(routes.classroomTypes);
      case routes.vacancies:
        return routes.routeName(routes.vacancies);
      case routes.createVacancy:
        return routes.routeName(routes.createVacancy);
      case routes.updateVacancy:
        return routes.routeName(routes.updateVacancy);
      case routes.manageSchedule:
        return routes.routeName(routes.classes);
      case routes.studentSchedule:
        return routes.routeName(routes.studentSchedule);
      case routes.studentGrades:
        return routes.routeName(routes.studentGrades);
      case routes.myAssessments:
        return routes.routeName(routes.myAssessments);
      case routes.createTeacherEvaluationCriteria:
        return routes.routeName(routes.createTeacherEvaluationCriteria);
      case routes.updateTeacherEvaluationCriteria:
        return routes.routeName(routes.teacherEvaluationCriterias);
      case routes.teacherEvaluationCriterias:
        return routes.routeName(routes.teacherEvaluationCriterias);
      case routes.studentTeacherEvaluation:
        return routes.routeName(routes.studentTeacherEvaluation);
      case routes.teacherEvaluations:
        return routes.routeName(routes.teachers);
      case routes.studentDocuments:
        return routes.routeName(routes.studentDocuments);
      case routes.requestStudentDocument:
        return routes.routeName(routes.requestStudentDocument);
      case routes.findStudentGrades:
        return routes.routeName(routes.findStudentGrades);
      case routes.addSubjectPlan:
        return routes.routeName(routes.subjects);
      case routes.getSubjectPlans:
        return routes.routeName(routes.getSubjectPlans);
      case routes.getStudentFinanceState:
        return routes.routeName(routes.getStudentFinanceState);
      case routes.getStudentFinanceNotifications:
        return routes.routeName(routes.getStudentFinanceNotifications);
      case routes.curriculumGrid:
        return routes.routeName(routes.courses);
      // case routes.courseSubjectV2:
      //   return routes.routeName(routes.courseSubjectV2);
      case routes.createEnrollmentByStudentCode:
        return routes.routeName(routes.createEnrollmentByStudentCode);
      case routes.createStudentSituation:
        return routes.routeName(routes.createStudentSituation);
      case routes.students:
        return routes.routeName(routes.students);
      case routes.subscriptionsStatistics:
        return routes.routeName(routes.subscriptionsStatistics);
      case routes.subscriptionsStatisticsCourse:
        return routes.routeName(routes.subscriptionsStatisticsCourse);
      case routes.universities:
        return routes.routeName(routes.universities);
      case routes.createUniversity:
        return routes.routeName(routes.createUniversity);
      case routes.updateUniversity:
        return routes.routeName(routes.universities);
      case routes.studentStatistics:
        return routes.routeName(routes.studentStatistics);
      case routes.scholarshipTypes:
        return routes.routeName(routes.scholarshipTypes);
      case routes.updateScholarshipType:
        return routes.routeName(routes.scholarshipTypes);
      case routes.createScholarshipType:
        return routes.routeName(routes.createScholarshipType);
      case routes.createScholarshipProvider:
        return routes.routeName(routes.createScholarshipProvider);
      case routes.scholarshipProviders:
        return routes.routeName(routes.scholarshipProviders);
      case routes.updateScholarshipProvider:
        return routes.routeName(routes.scholarshipProviders);
      case routes.scholarships:
        return routes.routeName(routes.scholarships);
      case routes.createScholarship:
        return routes.routeName(routes.createScholarship);
      case routes.updateScholarship:
        return routes.routeName(routes.updateScholarship);
      case routes.updateClass:
        return routes.routeName(routes.classes);
      case routes.manageClassStudents:
        return routes.routeName(routes.classes);
      case routes.manageSchedule:
        return routes.routeName(routes.classes);
      case routes.generalStudentGrades:
        return routes.routeName(routes.classes);
      case routes.assignTeacherClassesSubjects:
        return routes.routeName(routes.classes);
      case routes.teacherClasses:
        return routes.routeName(routes.teacherClasses);
      case routes.changePasswordPolicy:
        return routes.routeName(routes.changePasswordPolicy);
      case routes.getPaymentReport:
        return routes.routeName(routes.getPaymentReport);
      case routes.duplicatedSchoolCodes:
        return routes.routeName(routes.duplicatedSchoolCodes);
      case routes.syncStudentsEsuraCentral:
        return routes.routeName(routes.syncStudentsEsuraCentral);
      case routes.planSubjects:
        return routes.routeName(routes.planSubjects);
      case routes.createUpdatePlanSubjects:
        return routes.routeName(routes.createUpdatePlanSubjects);
      case routes.getClassLessonPlans:
        return routes.routeName(routes.getClassLessonPlans);
      case routes.addStudentWithExcel:
        return routes.routeName(routes.addStudentWithExcel);
      case routes.processModels:
        return routes.routeName(routes.processModels);
      case routes.createProcessModel:
        return routes.routeName(routes.createProcessModel);
      case routes.updateProcessModel:
        return routes.routeName(routes.updateProcessModel);
      case routes.studentGeneralGrades:
        return routes.routeName(routes.studentGeneralGrades);
      case routes.certificates:
        return routes.routeName(routes.certificates);
      case routes.uploadStudentCertificate:
        return routes.routeName(routes.uploadStudentCertificate);
      default:
        return routes.routeName(routes.dashboard);
    }
  };

  const isActive = (route: string) => {
    return getCurrentPage() === routes.routeName(route) ? linkColor : 'transparent';
  };

  return { isActive };
};

export default useActiveMenu;